(function () {
  var root = document.querySelector('.gm-hl');
  if (!root) return;
  var grid = root.querySelector('.gm-hl__grid');
  var items = Array.prototype.slice.call(root.querySelectorAll('.gm-hl__item'));
  var panel = document.getElementById('gm-hl-panel');
  var input = document.getElementById('gm-hl-q');
  var count = root.querySelector('.gm-hl__count');
  var empty = root.querySelector('.gm-hl__empty');
  var state = { cat: '', sup: '', q: '' };
  var openSlug = null;

  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }

  function closePanel() {
    if (!openSlug) return;
    var btn = grid.querySelector('[data-slug="' + openSlug + '"] .gm-hl__card');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    panel.hidden = true; panel.innerHTML = ''; openSlug = null;
  }

  // the panel sits after the last visible card in the clicked card's row
  function placePanel(li) {
    var top = li.offsetTop, last = li, n = li.nextElementSibling;
    while (n) {
      if (n.classList.contains('gm-hl__item') && !n.hidden) { if (n.offsetTop !== top) break; last = n; }
      n = n.nextElementSibling;
    }
    last.after(panel);
  }

  // bring the clicked herb to the top so its panel opens in view; the theme header reappears when scrolling up
  function scrollToCard(li) {
    requestAnimationFrame(function () { scrollNow(li); });
  }
  function scrollNow(li) {
    var y = li.getBoundingClientRect().top + window.pageYOffset;
    var hdr = document.querySelector('sticky-header');
    var off = 12 + (y < window.pageYOffset && hdr ? hdr.offsetHeight : 0);
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y - off), behavior: still ? 'auto' : 'smooth' });
  }

  function open(slug) {
    var li = grid.querySelector('[data-slug="' + slug + '"]');
    var src = document.getElementById('gm-hl-' + slug);
    if (!li || !src) return;
    if (li.hidden) { setFilter('cat', ''); setFilter('sup', ''); input.value = ''; state.q = ''; apply(); }
    if (openSlug === slug) { closePanel(); return; }
    var before = li.getBoundingClientRect().top;
    closePanel();
    panel.hidden = true;
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(src.children, function (c) { frag.appendChild(c.cloneNode(true)); });
    // show the card's already-loaded image straight away, then swap to the larger one once it's in
    var pi = frag.querySelector('.gm-hl__dimg img'), ci = li.querySelector('.gm-hl__img img');
    if (pi && ci && ci.complete && ci.currentSrc && ci.currentSrc.indexOf('_640x.') < 0) {
      var hi = pi.getAttribute('src'), pre = new Image();
      pi.src = ci.currentSrc;
      pre.onload = function () { pi.src = hi; };
      pre.src = hi;
    }
    panel.innerHTML = ''; panel.appendChild(frag);
    panel.hidden = false; placePanel(li);
    li.querySelector('.gm-hl__card').setAttribute('aria-expanded', 'true');
    openSlug = slug;
    // closing a panel above shifts this card up; hold it where it was so the scroll is one smooth move
    var shift = li.getBoundingClientRect().top - before;
    if (shift) {
      var hdr = document.querySelector('sticky-header');
      if (hdr && shift < 0) hdr.preventReveal = true;
      window.scrollTo({ top: window.pageYOffset + shift, behavior: 'auto' });
    }
    scrollToCard(li);
    if (history.replaceState) history.replaceState(null, '', '#' + slug);
  }

  function apply() {
    var q = norm(state.q), shown = 0;
    items.forEach(function (li) {
      var ok = (!state.cat || (' ' + li.dataset.cats + ' ').indexOf(' ' + state.cat + ' ') > -1) &&
               (!state.sup || (' ' + li.dataset.sup + ' ').indexOf(' ' + state.sup + ' ') > -1) &&
               (!q || norm(li.dataset.search).indexOf(q) > -1);
      li.hidden = !ok; if (ok) shown++;
    });
    if (openSlug) {
      var li = grid.querySelector('[data-slug="' + openSlug + '"]');
      if (li && !li.hidden) placePanel(li); else closePanel();
    }
    count.textContent = (count.dataset.tpl || '').replace('{n}', shown);
    empty.hidden = shown > 0;
  }

  function setFilter(kind, val) {
    state[kind] = val;
    root.querySelectorAll('.gm-hl__f').forEach(function (b) {
      if (kind === 'cat' && b.hasAttribute('data-cat')) b.classList.toggle('is-on', b.dataset.cat === val);
      if (kind === 'sup' && b.hasAttribute('data-sup')) b.classList.toggle('is-on', b.dataset.sup === val);
    });
  }

  root.addEventListener('click', function (e) {
    var f = e.target.closest('.gm-hl__f');
    if (f) {
      if (f.hasAttribute('data-cat')) setFilter('cat', f.dataset.cat);
      else setFilter('sup', state.sup === f.dataset.sup ? '' : f.dataset.sup);
      apply(); return;
    }
    if (e.target.closest('.gm-hl__close')) { closePanel(); return; }
    var chip = e.target.closest('.gm-hl__chip');
    if (chip) { open(chip.dataset.open); return; }
    var card = e.target.closest('.gm-hl__card');
    if (card) open(card.closest('.gm-hl__item').dataset.slug);
  });
  input.addEventListener('input', function () { state.q = input.value; apply(); });
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { if (openSlug) placePanel(grid.querySelector('[data-slug="' + openSlug + '"]')); }, 150); });
  apply();
  if (location.hash.length > 1) open(location.hash.slice(1));
})();
